import escape = require("../state 2 interface/createEscapedCsvHeader");

export class CsvColumnPathBuilder {
	constructor(private build_steps: ((tail: string) => string)[] = []) {}

	static create(): CsvColumnPathBuilder {
		return new CsvColumnPathBuilder();
	}

	copyBuildSteps(): ((tail: string) => string)[] {
		return this.build_steps.slice();
	}
	newBuilder(build_function: (tail: string) => string): CsvColumnPathBuilder {
		return new CsvColumnPathBuilder([...this.build_steps, build_function]);
	}
	clone(): CsvColumnPathBuilder {
		return new CsvColumnPathBuilder(this.copyBuildSteps());
	}
	removeTail(): CsvColumnPathBuilder {
		return new CsvColumnPathBuilder(this.build_steps.slice(0, -1));
	}

	group(group: string): CsvColumnPathBuilder {
		return this.newBuilder((tail) => escape(group) + "+" + tail);
	}

	state(state_group: string, state: string): CsvColumnPathBuilder {
		return this.newBuilder((tail) => escape(state) + "*" + escape(state_group) + "?" + tail);
	}

	state_group(state_group: string): CsvColumnPathBuilder {
		return this.newBuilder((tail) => escape(state_group) + "?" + tail);
	}

	state_group_operation(state_group: string): CsvColumnPathBuilder {
		return this.newBuilder((tail) => escape(state_group) + "_operation" + "?" + tail);
	}

	text(text: string): CsvColumnPathBuilder {
		return this.newBuilder((tail) => escape(text) + ":" + tail);
	}

	number(number: string): CsvColumnPathBuilder {
		return this.newBuilder((tail) => escape(number) + "#" + tail);
	}

	build(): string {
		return this.build_steps.reduce((tail, build_step) => build_step(tail), "");
	}
}
